module.exports = __webpack_public_path__ + "09805da43acdd1192c972f2973bb2018.png";